<template>
    <div id="location_map" style="height: 100%;">

    </div>
</template>

<style lang="scss">
    .marker {
        background-image: url('~@/assets/img/logos/ijstijd.svg');
        background-size: cover;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        cursor: pointer;
    }

    .mapboxgl-popup-content {
        text-align: center;
        padding: 20px 30px 20px;

        font-size: 120%;

        button.choose {
            background-color: #F26523;
            color: #ffffff;
            border-radius: 5px;
            padding: 1rem;
            margin-top: 1rem;
            width: 80%;
        }
    }

    .mapboxgl-popup-close-button {
        padding: 5px;
    }
</style>

<script>
    import 'mapbox-gl/dist/mapbox-gl.css';
    import MapboxGL, {LngLatBounds} from "mapbox-gl";

    const parser = new DOMParser();

    export default {
        props: {
            locations: {
                type: Array,
                required: true
            }
        },
        mounted() {
            this.initializeMap();
        },
        methods: {

            initializeMap() {
                MapboxGL.accessToken = process.env.VUE_APP_MAPBOX;

                const map = new MapboxGL.Map({
                    container: 'location_map',
                    style: 'mapbox://styles/sportunity/cjhp3uao83qy32smdqhqq1oti',
                    scrollZoom: true,
                    center: [5.104480, 52.092876]

                });

                const click = (marker) => {
                    this.$emit('chosen', marker);
                };

                map.on('load', () => {
                    const bounds = this.coordinates.reduce(function (bounds, coord) {
                        return bounds.extend(coord);
                    }, new LngLatBounds((this.coordinates)[0], (this.coordinates)[0]));

                    map.fitBounds(bounds, {
                        padding: 80,
                        duration: 500
                    });

                    this.locationGeoJson.features.forEach(function (marker) {
                        const button = document.createElement('button');
                        button.innerText = 'Kies!';
                        button.classList.add('choose');

                        button.addEventListener('click', function () {
                            click(marker.properties);
                        });

                        // create a HTML element for each feature
                        const el = document.createElement('div');
                        el.className = 'marker';

                        const content = document.createElement('div');

                        const title = document.createElement('h6');
                        title.innerText = marker.properties.label;

                        const p2 = document.createElement('p');
                        p2.appendChild(button);

                        content.appendChild(title);

                        if (marker.properties.thumbnail) {
                            const img = document.createElement('img');
                            img.src = marker.properties.thumbnail;
                            content.appendChild(img);
                        }

                        content.appendChild(p2);

                        new MapboxGL.Marker(el)
                            .setLngLat(marker.geometry.coordinates)
                            .setPopup(
                                new MapboxGL.Popup({offset: 0}).setDOMContent(content)
                            ).addTo(map);
                    });
                });
            },
        },
        computed: {
            locationGeoJson() {
                return {
                    type: 'FeatureCollection',
                    features: this.locations.filter(item => item.coordinates).map(point => {
                        return {
                            type: 'Feature',
                            geometry: point.coordinates,
                            properties: point
                        }
                    })
                }
            },
            coordinates() {
                return this.locations.map((item) => {
                    return item.coordinates.coordinates;
                })
            },
        },

        components: {}
    }
</script>
